/*
 * @Descripttion: 菜单数据重组
 * @Date: 2026-05-13 16:24:28
 */
import { storeToRefs } from 'pinia';
import _ from 'lodash';

import appStore from '@/store';
import { actOpenInfo } from '@/views/account/src/data-source/apis';
import { zsManageIsHidden } from '@/common/data-source/common/apis';

/**
 * 递归过滤菜单数据
 */
const filterMenusByAsp = ({ data, info, zsData, bankData }) => {
  return data.filter(item => {
    // 基地服务商权限过滤
    if (item.isBaseAsp === 1) return info.isBaseAsp === 1;

    // 招商管理特殊处理
    if (item.url === '/zs-manage') return zsData;

    // 代办供应商未开通富友户，不可操作园区管理菜单。
    if (item.url === '/park-mgmt-list' && info.functionCode === 8) {
      return bankData?.fyBank.actOpenStatus === 30;
    }

    // 递归处理子菜单
    if (item.menuList && item.menuList.length > 0) {
      item.menuList = filterMenusByAsp({
        data: item.menuList,
        info,
        zsData,
        bankData
      });
    }

    return true;
  });
};

export const menusFormatting = async data => {
  const { info } = storeToRefs(appStore.useUserStoreSetup);

  if (info.value.entpAuthStatus === 30) {
    const homePageIndex = data.findIndex(item =>
      ['/main/project-center'].includes(item?.url)
    );
    if (homePageIndex !== -1) {
      const homePageMenus = _.cloneDeep(data[homePageIndex]);
      const newMenus: any = homePageMenus.menuList.reduce(
        (obj, menu) => {
          if (menu.url === '/main/project-center-list') {
            obj.homePage = menu;
          } else {
            obj.otherPage.menuList.push(menu);
          }
          return obj;
        },
        {
          homePage: {},
          otherPage: {
            id: Date.now(),
            url: '/main/project-center-detail/hide',
            name: '项目中心子级菜单',
            permissionDef: '24534',
            resourceType: 4,
            icon: null,
            sort: 259,
            menuList: [],
            _hide: true
          }
        }
      );
      data.splice(homePageIndex, 1);
      data.unshift({
        ...newMenus.homePage,
        name: '项目中心'
      });
      data.push(newMenus.otherPage);
    }

    const needZs = data.some(i => i.url === '/zs-manage');
    const needPark =
      info.value.functionCode === 8 &&
      data.some(i => i.url === '/park-mgmt-list');

    const [{ data: zsData }, { data: bankData }] = await Promise.all([
      needZs ? zsManageIsHidden() : Promise.resolve({ data: true }),
      needPark ? actOpenInfo() : Promise.resolve({ data: null })
    ]);

    return filterMenusByAsp({ data, info: info.value, zsData, bankData });
  } else {
    return data;
  }
};
